import ScrollMagic from 'scrollmagic';
import 'debug.addIndicators';

let scene;

function setMapHeight() {
  const windowHeight = window.innerHeight;
  const header = document.querySelector('.js-header');
  const mapHeight = windowHeight - header.offsetHeight - 96;
  const map = document.querySelector('.js-location-list-map');
  map.style.height = `${mapHeight}px`;
}

const initStickyMap = () => {
  const triggerElement = document.querySelector('.js-location-list-container');
  const windowHeight = window.innerHeight;
  const header = document.querySelector('.js-header');
  const mapHeight = windowHeight - header.offsetHeight - 96;
  const locationMapBlock = document.querySelector('.js-sticky-location-map');

  if (locationMapBlock) {
    const controller = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement,
      triggerHook: 'onLeave',
      offset: -header.offsetHeight - 48,
      duration: triggerElement.offsetHeight - mapHeight - 24
    })
      .setPin('.js-sticky-location-map')
      // .addIndicators()
      .addTo(controller);

    setMapHeight();
  }
};

export function destroyStickyMap() {
  if (scene) {
    scene.destroy(true);
  }
}

const eventHandler = () => {
  window.addEventListener('resize', () => {
    if (window.innerWidth < 801) {
      destroyStickyMap();
    } else {
      destroyStickyMap();
      initStickyMap();
    }
  });
};

const stickyMap = async () => {
  eventHandler();
  initStickyMap();
};

export default stickyMap;
